import { render, staticRenderFns } from "./buyChangeCardQuestion.vue?vue&type=template&id=4d3cb628&"
import script from "./buyChangeCardQuestion.vue?vue&type=script&lang=js&"
export * from "./buyChangeCardQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports